import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { BaseFormControlledModal } from "../../../../../../../common/components/base_form_controlled_modal";
import FormContainer from "../../../../../../../common/components/form_container";
import DefaultFormInput from "../../../../../../../common/components/default_form_input";
import { ObraEstruturaTreinamentoForm, ObraEstruturaTreinamentoSchema } from "../../../../schemas/Obras_treinamentos/obra_estrutura_treinamento";
import { PlanoTreinamentoLista } from "../../../../../domain/models/plano_treinamento_lista";
import { useEffect } from "react";


// EstTreinamentoModal
 
type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedPlanoTreinamento: PlanoTreinamentoLista | undefined,
  onClose: () => void;
  onSubmit: (e: ObraEstruturaTreinamentoForm) => void;
  
};

export const EstTreinamentoModal = ({
  open,
  saving,
  loading,
  selectedPlanoTreinamento,
  onClose,
  onSubmit
}: Props) => {
    const hookForm = useForm<ObraEstruturaTreinamentoForm>({
      mode: 'onSubmit',
      reValidateMode: 'onSubmit',
      resolver: zodResolver(ObraEstruturaTreinamentoSchema),
    });

    useEffect(() => {
        if (open) {
          if (selectedPlanoTreinamento) {
            hookForm.setValue('cargo', selectedPlanoTreinamento.Cargo ?? '');
            hookForm.setValue('TIPO_TREINAMENTO', selectedPlanoTreinamento.TipoTreinamento);
           
          } else 
              hookForm.reset();
        }
      }, [ open, selectedPlanoTreinamento, hookForm ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title={'Estutura Treinamento'}
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <FormContainer title={"Adicionar Novo Treinamento"} arrangement="fullRow">
        <>
          <DefaultFormInput
            name='cargo'
            label='Cargo'
            multiline={true}
            minRows={2}
            required={true}
            reactHookForm={hookForm} />
            
            <DefaultFormInput
            name='TIPO_TREINAMENTO'
            label='Descrição'
            multiline={true}
            minRows={4}
            required={true}
            reactHookForm={hookForm} />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}